<script>
import settings from '@/settings.js';
import service from '@/service';
import { format, parse } from 'date-fns';

export default {
	methods: {
		showModal: function (id, lokacija, datumDobave) {
			this.item_id = id;
			this.lokacija_selected = null;
			if (lokacija) {
				for (let item of this.lokacija_options) {
					if (lokacija === item.value) {
						this.lokacija_selected = item;
						break;
					}
				}
			}
			this.datum_dobave = '';
			if (datumDobave) {
				let dp = parse(datumDobave, settings.dbDtFormat);
				this.datum_dobave = format(dp, settings.inputDtFormat);
			}
			this.$refs.modal.show();
		},
		onOkModal: function (evt) {
			evt.preventDefault()
			if (this.item_id != null && this.lokacija_selected != null && this.datum_dobave !== '') {
				service.dobavivKoncesijo(this.item_id, this.user, this.lokacija_selected, this.datum_dobave)
					.then(response => {
						this.$refs.modal.hide();
						this.$emit('prodajavkoncesijo-success');
					})
					.catch(error => {
						if (error) {
							console.log(error);
						}
					});
			}
		}
	},
	data: function () {
		return {
			item_id: null,
			datum_dobave: '',
			lokacija_selected: null,
			lokacija_options: [
				{
					label: 'CC (city center)',
					value: 'CC'
				},
				{
					label: 'ŠO (šotor)',
					value: 'ŠO'
				},
				{
					label: 'DV (dvorišče)',
					value: 'DV'
				},
				{
					label: 'OG (ograja)',
					value: 'OG'
				},
				{
					label: 'Ostalo',
					value: 'Ostalo'
				}
			]
		}
	},
	computed: {
		user () {
			return this.$store.getters.user;
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" title="Dobava v koncesijo" class="modal-primary" ok-title="Potrdi" cancel-title="Prekliči" @ok="onOkModal">
		<b-row>
			<b-col>
				<b-form-group>
					<label>Lokacija</label>
					<v-select ref="lokacija"
						v-model="lokacija_selected"
						:options="lokacija_options"
						placeholder="Izberi lokacijo ...">
					</v-select>
				</b-form-group>
			</b-col>
			<b-col>
				<b-form-group label="Datum dobave:" label-for="datum_dobave">
					<b-form-input ref="datum_dobave" id="datum_dobave"
						type="date"
						v-model="datum_dobave"
						required
						placeholder="Datum dobave"></b-form-input>
				</b-form-group>
			</b-col>
		</b-row>
	</b-modal>
</template>
<style>
.dropdown-toggle::after {
	border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/DobavavKoncesijoModal.vue